import React from 'react';
import {
  Box,
  Typography,
  Alert,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
  Divider
} from '@mui/material';
import { ExpandMore, Download, Folder } from '@mui/icons-material';
import { getDocumentTypeLabel, groupDocumentsByType } from '../AircraftDetails';
import { COLORS, glassCardSx, accentBarSx, floatingIconSx, alertInfoSx, accordionSummarySx } from './clientPortalTheme';

const ClientDocumentsPanel = ({ documents, aircraftId, onDocumentDownload }) => {
  const groupedDocs = groupDocumentsByType(documents || []);

  if (!documents?.length) {
    return <Alert severity="info" sx={{ ...alertInfoSx }}>No documents available for this aircraft.</Alert>;
  }

  return (
    <Box>
      <Box sx={{ ...accentBarSx, mb: 2, alignItems: 'center' }}>
        <Typography variant="h6" fontWeight={800} sx={{ color: COLORS.text, display: 'flex', alignItems: 'center', gap: 1 }}>
          <Folder sx={{ color: COLORS.indigo }} />
          Document Library
        </Typography>
      </Box>
      {Object.keys(groupedDocs).map((docType) => (
        <Accordion
          key={docType}
          sx={{
            mt: 1.5,
            borderRadius: '16px !important',
            overflow: 'hidden',
            ...glassCardSx,
            '&:before': { display: 'none' }
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMore sx={{ color: COLORS.grey }} />}
            sx={accordionSummarySx}
          >
            <Typography variant="subtitle1" fontWeight={700} sx={{ color: COLORS.text }}>
              {getDocumentTypeLabel(docType)} ({groupedDocs[docType].length})
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <List>
              {groupedDocs[docType].map((doc, idx) => (
                <React.Fragment key={doc._id}>
                  <ListItem>
                    <ListItemText
                      primary={`${doc.originalFileName} (v${doc.version})`}
                      primaryTypographyProps={{ sx: { color: COLORS.text } }}
                      secondaryTypographyProps={{ sx: { color: COLORS.textMuted } }}
                      secondary={
                        <>
                          Uploaded: {new Date(doc.uploadedAt).toLocaleString()}
                          {doc.uploadedBy && ` by ${doc.uploadedBy.firstName} ${doc.uploadedBy.lastName}`}
                          {doc.description && ` — ${doc.description}`}
                        </>
                      }
                    />
                    <ListItemSecondaryAction>
                      <IconButton
                        edge="end"
                        onClick={() => onDocumentDownload(aircraftId, doc._id, doc.originalFileName)}
                        sx={{
                          ...floatingIconSx,
                          width: 36,
                          height: 36,
                          bgcolor: COLORS.indigo
                        }}
                      >
                        <Download sx={{ fontSize: 18 }} />
                      </IconButton>
                    </ListItemSecondaryAction>
                  </ListItem>
                  {idx < groupedDocs[docType].length - 1 && <Divider sx={{ borderColor: COLORS.glassBorder }} />}
                </React.Fragment>
              ))}
            </List>
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};

export default ClientDocumentsPanel;
